import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'mobx-react';
import {configure} from 'mobx';
import qs from 'qs';
import {message} from '@enos/dpl';
import {BrowserRouter as Router} from 'react-router-dom';
import BaseRoute from './components/BaseRoute';
import routes from './routes';
import stores from './stores';
import * as serviceWorker from './utils/serviceWorker';
import {enableDplLang} from '~/utils/tools';
import {createModalHistoryHandler} from '~/utils/modalStack';
import PortalStorage from './utils/portalStorage';
import version from '~/utils/version';
import {QUERY_ENTICES_KEY} from '~/utils/constants';

// global configs
enableDplLang();

configure({
  enforceActions: 'always'
});

message.config({
  top: 60,
  duration: 5
});
// For easier debugging
// eslint-disable-next-line
window._____APP_STATE_____ = stores;

version();

const getConfirmation = (action, callback) => {
  // handler modal back
  createModalHistoryHandler(action, callback);
};

// Storage encrypt and decrypt
PortalStorage('1234123412ABCDEF', 'ABCDEF1234123412'); // iv密钥偏移量, key密钥，均为十六位十六进制数

ReactDOM.render(
  <Provider {...stores}>
    <Router getUserConfirmation={getConfirmation}>
      <BaseRoute routes={routes} />
    </Router>
  </Provider>,
  document.getElementById('root')
);

window.addEventListener(
  'message', (event) => {
    const switchData = event.data;
    if (switchData?.type === 'APP_PORTAL_OUTER') {
      const params = qs.parse(new URL(switchData.url).search.slice(1));
      const appId = params.appId;
      const menuCode = params.menuCode;
      const viewMode = params.viewMode;
      delete params.appId;
      delete params.menuCode;
      delete params.viewMode;
      sessionStorage.setItem(QUERY_ENTICES_KEY, qs.stringify(params));
      const timer = setInterval(() => {
        if (window.$sdk$) {
          window.$sdk$.switchPage({
            appId,
            menuCode
          });
          window.$sdk$.setViewMode(viewMode);
          window.top.postMessage({type: 'APP_PORTAL_SUCCESS'}, '*');
          clearInterval(timer);
        }
      }, 200);
    }
  });

serviceWorker.unregister();
